/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

// ---- B&B v13 (1 Nov 2026): Terms of Service checkbox in the cart drawer and on the cart page ----
// The theme (assets/cart.js, initTermsCheckbox) keeps the Checkout button disabled until the box is
// ticked. A disabled button ignores taps (Bootstrap gives it pointer-events: none), so the tap lands on
// the form underneath and nothing seemed to happen. Use that tap to show why: mark the box and show the
// message that snippets/cart-terms-checkbox renders (hidden) under it. What is required does not change.
(function () {
    function termsParts (form) {
        var box = form && form.querySelector('#cart-terms-checkbox')
        if (!box) return null
        return {
            box: box,
            row: box.closest('.bb-terms'),
            msg: form.querySelector('.bb-terms-msg'),
            btn: form.querySelector('.btn-checkout')
        }
    }
    document.addEventListener('click', function (e) {
        var form = e.target && e.target.closest ? e.target.closest('form') : null
        var p = termsParts(form)
        if (!p || !p.btn || p.box.checked || !p.btn.disabled) return
        var r = p.btn.getBoundingClientRect()
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return
        if (p.msg) {
            p.msg.hidden = false
            if (p.msg.id) p.box.setAttribute('aria-describedby', p.msg.id)
        }
        p.box.setAttribute('aria-invalid', 'true')
        if (p.row) {
            p.row.classList.add('bb-terms--error')
            p.row.classList.remove('bb-terms--shake')
            void p.row.offsetWidth
            p.row.classList.add('bb-terms--shake')
        }
        p.box.focus({ preventScroll: true })
    })
    document.addEventListener('change', function (e) {
        if (!e.target || e.target.id !== 'cart-terms-checkbox' || !e.target.checked) return
        var p = termsParts(e.target.form)
        if (!p) return
        if (p.msg) p.msg.hidden = true
        p.box.removeAttribute('aria-invalid')
        p.box.removeAttribute('aria-describedby')
        if (p.row) p.row.classList.remove('bb-terms--error', 'bb-terms--shake')
    })
})()

/* B&B v14 (2 Nov 2026): product page price after a size or colour change.
   The theme's product.js writes "€21.95 EUR" when a variant is picked and rebuilds the
   Add to basket button without its price. This wrapper removes the currency code (the €
   sign is enough) and puts the price back on the button. product.js itself is unchanged. */
;(function () {
  var original = window.onChangeProductOption;
  if (typeof original !== 'function') return;

  function currencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.theme && window.theme.currency) || 'EUR';
  }

  function stripCode(root) {
    var re = new RegExp('\\s*\\b' + currencyCode() + '\\b\\s*$');
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (re.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(re, ' ');
    }
  }

  function tidy(input, btn, hadPrice) {
    try {
      var content = input.closest('.product-content');
      var priceBox = content && content.querySelector('.product-price');
      if (priceBox) stripCode(priceBox);
      if (hadPrice && btn && !btn.disabled && !btn.querySelector('.btn-atc-price')) {
        var finalPrice = priceBox && priceBox.querySelector('.product-price-final');
        var text = finalPrice ? finalPrice.textContent.trim() : '';
        if (text) {
          btn.insertAdjacentHTML('beforeend', ' - <span class="btn-atc-price"></span>');
          btn.querySelector('.btn-atc-price').textContent = text;
        }
      }
    } catch (e) {}
  }

  document.querySelectorAll('.btn-atc').forEach(function (b) {
    if (b.querySelector('.btn-atc-price')) b.dataset.bbAtcPrice = '1';
  });

  window.onChangeProductOption = function (input) {
    var form = input && input.closest ? input.closest('form') : null;
    var btn = form ? form.querySelector('.btn-atc') : null;
    var hadPrice = !!(btn && (btn.dataset.bbAtcPrice === '1' || btn.querySelector('.btn-atc-price')));
    if (hadPrice) btn.dataset.bbAtcPrice = '1';
    var result = original.apply(this, arguments);
    tidy(input, btn, hadPrice);
    if (result && typeof result.then === 'function') {
      result.then(function () { tidy(input, btn, hadPrice); });
    }
    return result;
  };
})();

/* B&B v15 (2 Nov 2026): Splide gives the <li> slides of list-based carousels (e.g. "You may
   also like") role="group", which is not allowed on <li> and breaks the list for screen readers
   and AI agents (Lighthouse "aria-allowed-role", agentic accessibility tree). Remove that role so
   each slide is a normal list item inside its <ul>. The product gallery itself now uses <div>s. */
;(function () {
  function fix() {
    document.querySelectorAll('ul.splide__list > li.splide__slide[role]').forEach(function (li) {
      li.removeAttribute('role');
    });
  }
  fix();
  document.addEventListener('DOMContentLoaded', fix);
  window.addEventListener('load', fix);
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; fix(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['role'] });
  }
})();
